"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const typography_1 = require("../../shared/typography");
const styled_components_1 = __importDefault(require("styled-components"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const AppContexts_1 = require("../../shared/AppContexts");
const moment_1 = __importDefault(require("moment"));
const icons_1 = require("../icons");
const faTimesCircle_1 = require("@fortawesome/pro-solid-svg-icons/faTimesCircle");
const Input = (0, react_1.forwardRef)(({ defaultValue = "", type = "text", placeholder, onReset = undefined, ...props }, ref) => {
    const wrapperRef = (0, react_1.useRef)(null);
    const inputVisibleRef = (0, react_1.useRef)(null);
    const { timeFormat } = (0, AppContexts_1.useUserSettingsContext)();
    const dateFormat = timeFormat.split(" ")[0];
    (0, react_1.useEffect)(() => {
        var _a;
        if (!wrapperRef || type !== "date")
            return;
        const isDesktopSafari = !navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
            /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        //Unfortunetly safari doesn't have date pickers....
        if (isDesktopSafari) {
            if (inputVisibleRef.current) {
                inputVisibleRef.current.style.display = "none";
            }
            if (wrapperRef.current) {
                const dateInput = wrapperRef.current.querySelector('[type="date"]');
                dateInput.style.opacity = "1";
                dateInput.style.color = "revert";
                wrapperRef.current.querySelector("svg").style.display = "none";
            }
            return;
        }
        const input = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('[type="date"]');
        const onChange = (e) => {
            if (inputVisibleRef.current) {
                inputVisibleRef.current.value = e.target.value
                    ? (0, moment_1.default)(e.target.value).format(dateFormat)
                    : "";
            }
        };
        const onMouseEnter = () => {
            var _a;
            (_a = inputVisibleRef.current) === null || _a === void 0 ? void 0 : _a.classList.add("hover");
        };
        const onMouseLeave = () => {
            var _a;
            (_a = inputVisibleRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove("hover");
        };
        input === null || input === void 0 ? void 0 : input.addEventListener("input", onChange);
        input === null || input === void 0 ? void 0 : input.addEventListener("mouseenter", onMouseEnter);
        input === null || input === void 0 ? void 0 : input.addEventListener("mouseleave", onMouseLeave);
        return () => {
            input === null || input === void 0 ? void 0 : input.removeEventListener("input", onChange);
            input === null || input === void 0 ? void 0 : input.removeEventListener("mouseenter", onMouseEnter);
            input === null || input === void 0 ? void 0 : input.removeEventListener("mouseleave", onMouseLeave);
        };
    }, [wrapperRef]);
    return ((0, jsx_runtime_1.jsxs)(InputWrapper, { ref: wrapperRef, "data-type": type, children: [(0, jsx_runtime_1.jsx)(typography_1.Input, { ref: ref, type: type, value: props.value, name: props.name, disabled: props.disabled, required: props.required, onChange: props.onChange, placeholder: type == "date" ? "YYYY-MM-DD" : placeholder, "data-err": props.err, "data-cy": props["data-cy"], "data-testid": props.name }, void 0), type == "date" && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(typography_1.Input, { type: "text", value: props.value, placeholder: placeholder || dateFormat, ref: inputVisibleRef }, void 0), !props.icon && (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ["fas", "caret-down"] }, void 0)] }, void 0)), props.icon && !onReset && (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: props.icon }, void 0), props.err && (0, jsx_runtime_1.jsx)("p", { "data-cy": props["error-data-cy"], children: props.err }, void 0), type == "date" && props.value && !props.icon && ((0, jsx_runtime_1.jsx)(RemoveIcon, { children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "circle", icon: faTimesCircle_1.faTimesCircle, size: "lg", color: "grey", onClick: onReset }, void 0) }, void 0))] }, void 0));
});
exports.Input = Input;
const RemoveIcon = styled_components_1.default.div `
  align-items: center;
  background-color: ${({ theme }) => theme.colors.whiteBase};
  cursor: pointer;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 6px;
  right: 8px;
  z-index: 3;

  & svg {
    position: static !important;
  }
`;
const InputWrapper = styled_components_1.default.div `
  position: relative;
  svg {
    color: ${({ theme }) => theme.colors.greyLighten70};
    position: absolute;
    right: 1rem;
    top: calc(0.5rem + 1px);
    z-index: 2;
  }

  &[data-type="date"] {
    svg {
      color: ${({ theme }) => theme.colors.greyBase};
    }
  }

  input {
    position: relative;
    z-index: 3;
    &:hover,
    &.hover {
      color: ${(props) => props.theme.colors.greyLighten40};
      border-color: ${(props) => props.theme.colors.greyLighten40};
    }

    &:focus,
    &.focus {
      color: ${(props) => props.theme.colors.greyBase};
      border-color: ${(props) => props.theme.colors.greyLighten70};
    }

    &:disabled {
      background-color: ${(props) => props.theme.colors.silverLighten40};
      color: ${(props) => props.theme.colors.greyLighten70};
    }

    &:not(:last-child) {
      padding-right: 2.5rem;
    }

    &[type="date"] {
      opacity: 0;
      position: relative;
      height: 2.125rem;
      color: transparent;
      border: 1px solid ${({ theme }) => theme.colors.silverBase};
      &::-webkit-datetime-edit-year-field:not([aria-valuenow]),
      &::-webkit-datetime-edit-month-field:not([aria-valuenow]),
      &::-webkit-datetime-edit-text,
      &::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
        color: transparent;
      }
      &::-webkit-calendar-picker-indicator {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
      & + input {
        position: absolute;
        z-index: 1;
        left: 0;
        top: 0;
      }
    }

    &[type="date"]:disabled {
      border-color: ${(props) => props.theme.colors.silverBase};
    }
  }

  p {
    color: ${({ theme }) => theme.colors.pinkBase};
  }
`;
//# sourceMappingURL=input.js.map